import { useEffect, useState } from 'react';
import { authHeaders } from '../lib/api.ts';

/**
 * What the plan allows, what is in use, and what is left.
 *
 * Across the whole account, because that is how a plan is sold. The
 * per-site figure that used to sit here read as an allowance and was
 * not one.
 */
type Usage = {
  plan: string | null;
  allowance: number;
  devices: number;
  accounts: number;
  used: number;
  remaining: number;
  over: boolean;
};

export const NodeUsage = () => {
  const [u, setU] = useState<Usage | null>(null);

  useEffect(() => {
    fetch('/admin/nodes', {
      credentials: 'same-origin', headers: authHeaders(),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setU)
      .catch(() => undefined);
  }, []);

  if (!u) return null;

  return (
    <div className="nodeRow">
      <div className="nodeBox">
        <span className="mono">Plan nodes</span>
        <b>{u.allowance || '--'}</b>
        <em>{u.plan ?? 'no plan set'}</em>
      </div>

      <div className="nodeBox">
        <span className="mono">In use</span>
        <b>{u.used}</b>
        <em>
          {u.devices} device{u.devices === 1 ? '' : 's'}
          {' '}&middot;{' '}
          {u.accounts} account{u.accounts === 1 ? '' : 's'}
        </em>
      </div>

      <div className={u.over ? 'nodeBox over' : 'nodeBox'}>
        <span className="mono">Remaining</span>
        <b>{u.over ? 0 : u.remaining}</b>
        <em>
          {u.over
            ? `${u.used - u.allowance} over the plan`
            : 'available to enrol'}
        </em>
      </div>
    </div>
  );
};
